<template>
  <v-app class="login-section">
    <v-card rounded class="d-flex ma-auto" width="90%" elevation="15">
      <!-- pass through scoped slots -->
      <template
        v-for="(_, scopedSlotName) in $scopedSlots"
        v-slot:[scopedSlotName]="slotData"
      >
        <slot :name="scopedSlotName" v-bind="slotData" />
      </template>

      <!-- pass through normal slots -->
      <template v-for="(_, slotName) in $slots" v-slot:[slotName]>
        <slot :name="slotName" />
      </template>
    </v-card>
  </v-app>
</template>

<script>
export default {
  name: "SAuthLayout",
};
</script>

<style scoped>
.login-section {
  background-image: linear-gradient(to bottom, #006243d6, #00384deb),
    url("~@/assets/background.jpg") !important;
  background-size: cover !important;
  background-position: center !important;
}
</style>
